import i18next from "i18next";
import { useCallback } from "react";
import { fetchTranslations } from "../services/localizationService";

export const useLanguageService = () => {
  const handleSaveData = useCallback(async (language: string) => {
    const fetchedTranslations = await fetchTranslations(language);

    // Add null check before using addResourceBundle
    if (language && fetchedTranslations) {
      i18next.addResourceBundle(
        language,
        "translation",
        fetchedTranslations,
        true,
        true
      );
      i18next.changeLanguage(language);
    }
  }, []);

  return { handleSaveData };
};
